import { EvidenceBase } from '@shared/utils/evidence-management';

export const LIST_EVIDENCE_STORE_KEY = 'list-evidence';

export interface IListEvidenceState {
  evidence: EvidenceBase[];
  count: number;
  query: string;
  isLoadingEvidenceList: boolean;
  sharedWithMeEvidence: EvidenceBase[];
  sharedWithMeCount: number;
  isLoadingSharedWithMe: boolean;
}

export const initialState: IListEvidenceState = {
  evidence: [],
  count: 0,
  query: 'page=1&pageSize=10',
  isLoadingEvidenceList: false,
  sharedWithMeEvidence: [],
  sharedWithMeCount: 0,
  isLoadingSharedWithMe: false,
};
